<template>
    <GlobalWindow
        :title="title"
        :withFooter="false"
        :visible.sync="visible"
        :confirm-working="isWorking"
        @confirm="confirm"
    >
        <div class="box">
            {{form.content}}
        </div>
    </GlobalWindow>
</template>

<script>
  import BaseOpera from '@/components/base/BaseOpera'
  import GlobalWindow from '@/components/common/GlobalWindow'
  export default {
    name: 'OperaInterfaceLogWindow',
    extends: BaseOpera,
    components: { GlobalWindow },
    data () {
      return {
        // 表单数据
        form: {
          content: ''
        },
        // 验证规则
        rules: {
        }
      }
    },
    created () {
      this.config({
        api: '/business/interfaceLog',
        'field.id': 'id'
      })
    }
  }
</script>

<style lang="scss" scoped>
    .box {
        width: 100%;
        font-size: 15px;
        color: #222222;
        word-wrap: break-word;
    }
</style>
